module.exports = __webpack_public_path__ + "img/onlineToolsImg1.0a3dfc21.png";